export default function Grid({ children, cols }) {
    return <div className={`grid grid-cols-${cols}`}>{children}</div>
}
